// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_IRONING_PACKING_DC_REQUEST = 'FETCH_IRONING_PACKING_DC_REQUEST';
export const FETCH_IRONING_PACKING_DC_SUCCESS = 'FETCH_IRONING_PACKING_DC_SUCCESS';
export const FETCH_IRONING_PACKING_DC_FAILURE = 'FETCH_IRONING_PACKING_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_IRONING_PACKING_DC_REQUEST = 'CREATE_IRONING_PACKING_DC_REQUEST';
export const CREATE_IRONING_PACKING_DC_SUCCESS = 'CREATE_IRONING_PACKING_DC_SUCCESS';
export const CREATE_IRONING_PACKING_DC_FAILURE = 'CREATE_IRONING_PACKING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_IRONING_PACKING_DC = 'CREATE_USER_FORM_IRONING_PACKING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_IRONING_PACKING_DC_REQUEST = 'UPDATE_IRONING_PACKING_DC_REQUEST';
export const UPDATE_IRONING_PACKING_DC_SUCCESS = 'UPDATE_IRONING_PACKING_DC_SUCCESS';
export const UPDATE_IRONING_PACKING_DC_FAILURE = 'UPDATE_IRONING_PACKING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_IRONING_PACKING_DC_REQUEST = 'FETCH_SINGLE_IRONING_PACKING_DC_REQUEST';
export const FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS = 'FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS';
export const FETCH_SINGLE_IRONING_PACKING_DC_FAILURE = 'FETCH_SINGLE_IRONING_PACKING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_IRONING_PACKING_DC_REQUEST = 'DELETE_IRONING_PACKING_DC_REQUEST';
export const DELETE_IRONING_PACKING_DC_SUCCESS = 'DELETE_IRONING_PACKING_DC_SUCCESS';
export const DELETE_IRONING_PACKING_DC_FAILURE = 'DELETE_IRONING_PACKING_DC_FAILURE';

// USERFORM RESET

export const IRONING_PACKING_DC_USERFORM_RESET = 'IRONING_PACKING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_IRONING_PACKING_DC_DETAILS = 'NAVIGATE_IRONING_PACKING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_IRONING_PACKING_DC = 'NAVIGATE_IRONING_PACKING_DC';
export const IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

export const FETCH_IRONING_PACKING_DC_STYLE_REQUEST = 'FETCH_IRONING_PACKING_DC_STYLE_REQUEST';
export const FETCH_IRONING_PACKING_DC_STYLE_SUCCESS = 'FETCH_IRONING_PACKING_DC_STYLE_SUCCESS';
export const FETCH_IRONING_PACKING_DC_STYLE_FAILURE = 'FETCH_IRONING_PACKING_DC_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_IRONING_PACKING_DC_INVOICE_REQUEST = 'FETCH_IRONING_PACKING_DC_INVOICE_REQUEST';
export const FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS = 'FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS';
export const FETCH_IRONING_PACKING_DC_INVOICE_FAILURE = 'FETCH_IRONING_PACKING_DC_INVOICE_FAILURE';

export const RESET_IRONING_PACKING_DC_INVOICE = 'RESET_IRONING_PACKING_DC_INVOICE';

export const CLOSE_BTN_POST_REQUEST_REQUEST = 'CLOSE_BTN_POST_REQUEST_REQUEST';
export const CLOSE_BTN_POST_REQUEST_SUCCESS = 'CLOSE_BTN_POST_REQUEST_SUCCESS';
export const CLOSE_BTN_POST_REQUEST_FAILURE = 'CLOSE_BTN_POST_REQUEST_FAILURE';

export const NAVIGATE_IRONING_WITH_ACC_INITIAL = 'NAVIGATE_IRONING_WITH_ACC_INITIAL';
export const NAVIGATE_IRONING_WITH_ACC = 'NAVIGATE_IRONING_WITH_ACC';
export const NAVIGATE_IRONING_WITH_ACC_LAST = 'NAVIGATE_IRONING_WITH_ACC_LAST';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_IRONING_PACKING_DC_PRINT = 'NAVIGATE_IRONING_PACKING_DC_PRINT';